import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var Planificacion = Object.create(DatabaseModel);

Planificacion.model = 'planificacion';

Planificacion.clearCache = function() {
    var self = this;
    CacheService.clearCache(self.model);
};

Planificacion.borrarInspector = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/borrarInspector',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};
Planificacion.desplanificar = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/desplanificar',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

// C4-REALINEAMIENTO v2 (Modo B): borrado ACOTADO. Borra las PLANIFICADA del inspector en `dias` (nunca
// REALIZADA). data = { inspector, dias:[YYYY-MM-DD], soloListar }. soloListar=true → devuelve qué se
// borraría sin borrar (para el diálogo de confirmación). Reutiliza el endpoint acotado de movilidad.
Planificacion.borrarProvisionalDias = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/borrarProvisionalDias',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

// C4: "Limpiar pendientes de confirmar" del panel Proponer. Borra las PLANIFICADA + pendienteConfirmar=true
// del inspector en la ventana [fechaDesde,fechaHasta] + sus desplazamientos. data = { inspector, fechaDesde,
// fechaHasta, soloListar? }. Devuelve la lista borrada (o, con soloListar, la que se borraría).
Planificacion.limpiarPendientes = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/limpiarPendientes',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

// INTEGRIDAD (SPEC-INTEGRIDAD-REVERT-PROPUESTAS): CONFIRMA las pendientes del inspector en la ventana —
// aquí ocurren los cambios canónicos diferidos por el aceptar-aditivo (expedientes, segundas, SAP).
// data = { inspector, fechaDesde, fechaHasta, soloListar? }. Con soloListar devuelve el preview sin tocar.
Planificacion.confirmarPendientes = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/confirmarPendientes',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

// SPEC-REGISTRO-PROPUESTAS: consulta del audit-log de corridas de /proponer (solo lectura).
// data = { inspector?, usuario?, desde?, hasta?, estado?, limite? }. Devuelve los registros completos
// (solicitud + snapshot restricciones + proceso deductivo + resolución), orden cronológico inverso.
Planificacion.registroPropuestas = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/registro-propuestas/search',
        method: 'POST',
        data: params.data || {}
    };
    return self.sendRequest(request, false);
};

// SPEC-INFORME-PROPUESTA: informe completo de UNA corrida (por id de registro o runId). Devuelve
// { registro, lineas: {"pedido#linea": ctx}, pedidos: {"pedido": ctx} } — contexto resuelto al leer.
Planificacion.informePropuesta = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/registro-propuestas/informe',
        method: 'POST',
        data: params.data
    }, false);
};

// #460 (opción A, 16/10/2026): anota que una persona ha DESCARTADO a mano propuestas de una corrida
// antes de aceptarlas, para que esas unidades dejen de figurar como pendientes.
// data = { runId, inspector, motivo, bloques: [{ lineaId, numeroPedido, numLinea, horaInicio }] }.
// Solo viaja la REFERENCIA de los bloques: la unidad a la que pertenecen y el denominador de la
// corrida los deriva la API de la propuesta que tiene guardada, así que desde aquí no se puede fijar
// ni mover ningún número. Best-effort en el llamante: su fallo no cuesta el descarte.
Planificacion.descarteDeCorrida = function(params) {
    const self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/registro-propuestas/descarte',
        method: 'POST',
        data: params.data
    }, false);
};

Planificacion.calcularRuta = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/calcularRuta',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

// C4: pide una PROPUESTA al solver (vía movilidad). SOLO LECTURA: no escribe el calendario.
// data = { inspector, desde, hasta, planificarConComida, planificarConPernocta }
Planificacion.proponer = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/proponer',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false);
};

// ENCARGO-021c · vía ASÍNCRONA: /proponer/async devuelve 202 al instante con el `pasadaId`; el
// resultado y las fases viajan por SSE (canal `proponer-planificacion`, per-user). Ver
// `ProponerPlanificacionEvents.js`. La respuesta tiene dos formas:
//   { lanzado: true,  pasadaId, inspector, usuario }
//   { lanzado: false, pasadaId, inspector, usuario, pasadaEnCursoDe, motivo }
Planificacion.proponerAsync = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/proponer/async',
        method: 'POST',
        data: params.data
    }, false);
};

// Estado de una pasada por su `pasadaId` (200 al dueño, 403 a otro usuario, 404 si no existe,
// 503 si el bean del job no está montado). Se usa cuando el front SÍ recuerda el pasadaId
// (dentro de la misma sesión de pestaña). Para reengancharse tras F5 o al abrir el drawer se
// usa `proponerAsyncEnCurso(inspector)`.
Planificacion.proponerAsyncEstado = function(params) {
    var self = this;
    params = params || {};
    var pasadaId = params.pasadaId || (params.data && params.data.pasadaId);
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/proponer/async/' + encodeURIComponent(pasadaId),
        method: 'GET'
    }, false);
};

// Pasada VIVA o recientemente terminada del USUARIO CONECTADO para el inspector indicado. Se
// usa al abrir el drawer y en el reenganche tras F5 (el pasadaId puede haberse perdido). El
// backend nunca devuelve la pasada de otro usuario, aunque haya una viva para el inspector:
// 204 en ese caso. 503 si el bean del job no está montado.
Planificacion.proponerAsyncEnCurso = function(params) {
    var self = this;
    params = params || {};
    var inspector = params.inspector || (params.data && params.data.inspector);
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/proponer/async/en-curso?inspector=' + encodeURIComponent(inspector),
        method: 'GET'
    }, false);
};

// ENCARGO-023 · resultado COMPLETO de una pasada terminada en FIN. Devuelve exactamente el
// mismo `ProponerResponseDTO` que la vía síncrona `/planificacion/proponer`, con
// `bloqueadosNegocio` ya hidratado. Semántica:
//   200 al dueño con el DTO íntegro;
//   403 a otro usuario;
//   404 si el pasadaId no existe (nunca fue o ya se purgó por retención);
//   410 Gone si el DTO fue expulsado del cache (tope superado o purga temporal, o terminó en
//       ERROR); el cuerpo lleva `{motivo}` legible para pintarlo en la banda de vista reducida;
//   503 si el bean del job no está montado.
// El front llama a este método PRIMERO al recibir FIN. Solo si viene 410 recurre a
// `informePropuesta({id, runId})` como respaldo y pinta la banda permanente + deshabilita
// Aceptar (§2 del ENCARGO-023).
Planificacion.proponerAsyncResultado = function(params) {
    var self = this;
    params = params || {};
    var pasadaId = params.pasadaId || (params.data && params.data.pasadaId);
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/proponer/async/' + encodeURIComponent(pasadaId) + '/resultado',
        method: 'GET'
    }, false);
};

// SPEC-PARAMETRIZACION-PROPONER: preview LIGERO del drawer ("esto es lo que vas a proponer"). SOLO
// LECTURA, sin correr el solver. data = { inspector, mesesAntiguedadMax?, proponerInformes? }.
// Devuelve { ficha, campo:{colocables,segundasProximas,antiguas,sinCoordenadas,...}, informes, total, avisos }.
Planificacion.proponerPreview = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/proponer/preview',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false);
};

Planificacion.getDiario = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/getDiario',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

Planificacion.getDiarios = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/getDiarios',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

export default Planificacion;